import React from "react";
import moment from "moment";
import { Row, Col, Dropdown } from "react-bootstrap";
import { useParams, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import AnalyticsGrid from "../../components/dashboard/AnalyticsGrid";
import APIComponent from "../../components/API";
import core from "../../vendors/core-api";
import GroupDropdown from "../../components/dashboard/GroupDropdown";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import TitleHelmet from "../../partials/TitleHelmet";
import EmptyData from "../../components/EmptyData";
import StatCardApi from "../../components/widgets/StatCardApi";
import { toPesoAmount } from "../../helpers";
import { DB_DATE_FORMAT, DATERANGE_LIST } from "../../constants";
import DateRangeDropdown from "../../components/dashboard/DateRangeDropdown";
import PacmanWrapper from "../../components/dashboard/PacmanWrapper";

export default function Page() {
  const { brand_url = "" } = useParams(),
    { user } = useSelector((state) => state.auth);
  return <MainComponent id={brand_url} user={user} />;
}

class MainComponent extends APIComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSplashScreen: false,
      redirectTo: "",
      title: "Org Analytics",
      statCardQuery: "day",
      selectedBrand: { id: "", name: "All" },
      date: moment().format(DB_DATE_FORMAT),
    };

    this.api = core("pu").get();
    this.data_url = `/analytics`;

    this.handleDateRangeClick.bind(this);
  }

  handleDateRangeClick = async (e, date = moment().format(DB_DATE_FORMAT)) => {
    let statCardDataRange = "";
    const dropdownText = e.currentTarget.textContent || "day";

    if (
      dropdownText === "This Week" ||
      dropdownText === "Last Week" ||
      dropdownText === "Next Week"
    ) {
      statCardDataRange = "week";
    } else if (dropdownText === "This Month" || dropdownText === "Last Month") {
      statCardDataRange = "month";
    } else if (dropdownText === "This Year" || dropdownText === "Last Year") {
      statCardDataRange = "year";
    } else if (dropdownText === "All-time") {
      statCardDataRange = "allTime";
    } else {
      statCardDataRange = "day";
    }

    this.setState({
      statCardQuery: statCardDataRange,
      date,
      data_status: "fetching",
    });
    setTimeout(() => {
      this.getData();
    }, 500);
  };

  handleChangeSelectedBrand = async (item) => {
    this.setState({
      selectedBrand: item,
      data_status: "fetching",
    });
    setTimeout(() => {
      this.getData();
    }, 500);
  };

  async getData() {
    this._isMounted && this.setState({ data_status: "fetching" });
    let date = this.state.date || moment().format(DB_DATE_FORMAT);
    let statCardRange = this.state.statCardQuery || "day";
    let view = this.state.selectedBrand || { id: "", name: "All" };

    const getContent = () => {
      return new Promise((resolve, reject) => {
        this.api
          .get(
            `/analytics?dateRange=${statCardRange}&date=${date}&view=${view.id}`,
          )
          .then((data) => resolve(data.data))
          .catch((err) => reject(err));
      });
    };

    try {
      const content = await getContent();
      console.log("organalytics content: ", content);
      this._isMounted &&
        this.setState({
          data: {
            ...content,
          },
          data_status: "fetched",
          order_fetch_status: "fetched",
        });

      this.handleOnDataFetched();
      if (this.use_display_data) {
        this.setDisplayData();
      }
    } catch (error) {
      this._isMounted && this.setState({ error: error, showSwalError: true });
      this.handleOnDataFetchError();
    }
  }

  render() {
    const {
        data = {},
        data_status = "",
        selectedBrand = {},
        statCardQuery = "day",
        date = moment().format(DB_DATE_FORMAT),
      } = this.state,
      isLoading = data_status !== "fetched";

    const { allBrands = [] } = data;

    const allIds = allBrands.map(({ id }) => id);

    const params = {
      date,
      brands: this.props.brands,
      role: this.props.role,
      dateRange: statCardQuery,
      id: selectedBrand.id || "",
      attr: "brand",
    };

    function dropdownText(dateRange, date) {
      const isCurrent = moment(moment().format(DB_DATE_FORMAT)).isSame(
        date,
        dateRange,
      );

      const prefix = isCurrent ? "This" : "Last";

      // if(dateRange=== 'week') return `${prefix} Week`
      if (dateRange === "week") {
        if (
          moment(moment().add(1, "weeks").format(DB_DATE_FORMAT)).isSame(date)
        ) {
          return "Next Week";
        }

        return `${prefix} Week`;
      }
      if (dateRange === "month") return `${prefix} Month`;
      if (dateRange === "year") return `${prefix} Year`;
      if (dateRange === "allTime") return "All-time";
      return `${isCurrent ? "Today" : "Yesterday"}`;
    }

    return (
      <>
        <TitleHelmet title={this.state.title} />

        {this.state.showSplashScreen ? <LayoutSplashScreen /> : <></>}

        {this.state.redirectTo !== "" ? (
          <Redirect to={this.state.redirectTo} />
        ) : (
          <></>
        )}

        {isLoading ? (
          <PacmanWrapper removeBackgroundColor />
        ) : (
          <div className="">
            <div className="d-flex justify-content-end w-100 mb-4">
              <GroupDropdown
                items={allBrands}
                hasRollup={true}
                attr={selectedBrand.attr}
                onSelectView={this.handleChangeSelectedBrand}
                selectedView={selectedBrand}
                className={"mr-2"}
                isSuperAdmin={true}
              />

              <DateRangeDropdown
                className="align-self-end ml-4"
                onDateRangeSelect={this.handleDateRangeClick}
                statCardText={dropdownText(statCardQuery, date)}
                selectedDate={date}
                selectedRange={statCardQuery}
              />
            </div>

            <Row className="justify-content-around">
              <Col sm={12} lg={4} className="pl-4 pl-lg-0">
                <StatCardApi
                  icon="Shopping/Wallet2"
                  dateRange={statCardQuery}
                  data_url="/analytics/returning-customer/average-lifetime-spent"
                  title="Avg. lifetime spent of Returning customers"
                  statFormatter={(stat = 0) => toPesoAmount(stat)}
                />
              </Col>
              <Col sm={12} lg={4}>
                <StatCardApi
                  icon="Shopping/Bag1"
                  dateRange={statCardQuery}
                  date={date}
                  data_url="/analytics/average-basket-price"
                  title="Avg. Basket Size"
                  statFormatter={(stat = 0) => toPesoAmount(stat)}
                />
              </Col>
              <Col sm={12} lg={4}>
                <StatCardApi
                  icon="Media/Repeat"
                  dateRange={statCardQuery}
                  date={date}
                  data_url="/analytics/returning-customer/average-transaction"
                  title="Avg. Transaction of Returning customers"
                  statFormatter={(stat = 0) => stat.toFixed(2)}
                />
              </Col>
            </Row>

            <AnalyticsGrid
              itemSoldURL={`/dashboard/analytics/item-sold?date=${date}&dateRange=${statCardQuery}&id=${JSON.stringify(
                selectedBrand.id || allIds,
              )}&attr=${selectedBrand.attr || "brand"}`}
              selectedBrand={selectedBrand}
              data={data}
              statCardQuery={statCardQuery}
              date={date}
              params={params}
            />
          </div>
        )}
      </>
    );
  }
}
